<button mat-icon-button class="refresh-btn" [disabled]="clicked" (click)="onRefreshClick()">
    <app-fn-ui-icon icon="refresh" size="21px"></app-fn-ui-icon>
</button>
